import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SubscribersOnlyOwnersTooltip from './SubscribersOnlyOwnersTooltip';
import SubscribersOnlyTooltip from './SubscribersOnlyTooltip';

import s from './SubscribersOnly.scss';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
  textClassName?: string;
}

const SubscribersOnly: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  className,
  textClassName,
}) => {
  const { t } = useTranslation();
  const { tier, isOwner } = useSubscriptionTier(deviation);

  if (!tier || !tier.author) {
    return null;
  }

  const Tooltip = isOwner
    ? SubscribersOnlyOwnersTooltip
    : SubscribersOnlyTooltip;
  return (
    <div className={classnames(s['root'], className)}>
      <Tooltip deviation={deviation} linkClassName={s['subs-link']}>
        <div className={s['contents']}>
          <PromoBadge badgeType="tier" size={40} />
          <span className={classnames(s['text'], textClassName)}>
            {t('deviation.tier.subscribersOnly')}
          </span>
        </div>
      </Tooltip>
    </div>
  );
};
SubscribersOnly.displayName = 'SubscribersOnly';
export default SubscribersOnly;
